import { memo, ReactNode } from 'react';
import Portal from 'components/Portal/Portal';
import Modal, { Props as ModalProps } from 'components/Modal/Modal';

type Props = {
  renderContent: () => ReactNode;
} & ModalProps;

function PortalModal(props: Props) {
  const { renderContent, ...rest } = props;

  return (
    <Portal>
      <Modal {...rest}>{renderContent()}</Modal>
    </Portal>
  );
}

const PortalModalMemo = memo(PortalModal);

export default PortalModalMemo;
